import api from "../api/axios";

const PrintTemplateService = {
    getTemplate: async (templateType) => {
        const res = await api.get(`PrintTemplate/${templateType}`);
        return res.data;
    },
    saveTemplate: async (payload) => {
        const res = await api.post("PrintTemplate", payload);
        return res.data;
    }
};

export default PrintTemplateService;
